import { motion } from "framer-motion";
import { Gift } from "lucide-react";
import ReferralLinkCopy from "./ReferralLinkCopy";
import { useT } from "@/lib/i18n";

interface ReferralSectionProps {
  referralId: string;
  title?: string;
  description?: React.ReactNode;
  variant?: "card" | "inline";
  animationDelay?: number;
}

export default function ReferralSection({
  referralId,
  title,
  description,
  variant = "card",
  animationDelay = 0.1,
}: ReferralSectionProps) {
  const { t } = useT();
  const displayTitle = title || t('referral.inviteFriends');
  const defaultDescription = (
    <>
      {t('referral.shareCode')}
      <br />
      {t('referral.reward')}
    </>
  );

  const content = (
    <>
      <div className="flex items-center gap-2 mb-2">
        <Gift className="w-5 h-5 text-primary-500" />
        <h2 className="text-xl font-semibold dark:text-neutral-100">{displayTitle}</h2>
      </div>
      <p className="text-dark-muted dark:text-neutral-400 mb-4">
        {description || defaultDescription}
      </p>
      <ReferralLinkCopy referralId={referralId} />
    </>
  );

  if (variant === "inline") {
    return <div>{content}</div>;
  }

  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ delay: animationDelay }}
      className="card"
    >
      {content}
    </motion.div>
  );
}

